import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import '../../../assets/css/mobilefiltercss.css'; 
import FilterAllProduct from "../Filter/FilterAllProduct";
import {Link } from 'react-router-dom';

const SidebarModal = ({ position }) => {
   const [show, setShow] = useState(false);
   const handleShow = () => setShow(true);
   const handleClose = () => setShow(false);

  return (
    <>
      <Link onClick={handleShow} className="filter-border" style={{ textDecoration:"none", color:"rgb(137 133 133)" }}>
        Filter <i className="bi bi-sliders"></i> 
      </Link>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName={`modal-sidebar modal-dialogbx ${position === "left" ? "modal-left" : "modal-right"}`}
        backdrop="static" 
        keyboard={false} >
        <Modal.Header closeButton>
        <Modal.Title className="text-gray-500">  Filter  </Modal.Title>
        </Modal.Header>
        <Modal.Body>
         <FilterAllProduct/> 
         <div className="d-flex fixed-bottom" style={{ bottom: "57px" }}> 
            <Button className="btn btn-dark-bg-border"> Clear  </Button>
            <Button className="btn btn-dark-bg"> APPLY  </Button>
         </div> 
        </Modal.Body>
      </Modal>
    </>
  );
};
export default SidebarModal;